export const blockIconsHomeTempPreferencesEcoNew = (
	<span className='material-symbols-outlined'>temp_preferences_eco</span>
);
